export default __webpack_public_path__ + "images/magic-of-letters.svg";